import { IMockProps, ErrorResponseCodeType } from '_core/types';
import MocksDef from './MocksDef';

import {
  CODE_ERRORS,
  ENDPOINT_API_PATH,
} from '../Definitions/RecoverBigDataQuestionDef';

const autoGenerateSuccess = (login: string) => {
  const loginData =
    login.indexOf('@') >= 0 ? 'EMAIL' : login.length === 11 ? 'CPF' : 'MEMBER';

  let bodyRequest = {};
  switch (loginData) {
    case 'EMAIL':
      bodyRequest = {
        email: login,
      };
      break;
    case 'CPF':
      bodyRequest = {
        document: {
          type: 'CPF',
          value: login,
        },
      };
      break;
    case 'MEMBER':
      bodyRequest = {
        memberNumber: login,
      };
      break;
  }
  //}

  const dataResponse = {
    ticketId: MocksDef.TICKET_ID,
    totalQuestions: 3,
    totalAnswers: 5,
    questions: [
      {
        question: 'Qual é a última empresa que você trabalhou?',
        answers: [
          'Sandvik do Brasil',
          'Kennametal do Brasil',
          'Gerdau Brasil',
          'Mahle Metal Leve',
          'WEG S.A.',
        ],
      },
      {
        question: 'Qual foi o último voo feito pela empresa Gol?',
        answers: [
          'RJ > SP • Dezembro',
          'SP > ES • Dezembro',
          'POA > RJ • Dezembro',
          'ES > SP • Dezembro',
          'POA > SP • Dezembro',
        ],
      },
      {
        question: 'Qual dessas pessoas é da sua família?',
        answers: [
          'Raphaela Barros',
          'Rafael Barreto',
          'Rodrigo Barreto',
          'Rafaella Barreto',
          'Raphael de Barros',
        ],
      },
    ],
  };

  const recoverSuccess: IMockProps = {
    doc: {
      code: 'Validação com Sucesso',
      message: 'Validação com Sucesso',
    },
    configRequest: {
      method: 'POST',
      path: ENDPOINT_API_PATH,
      body: bodyRequest,
    },
    configResponse: {
      status: 200,
      data: dataResponse,
      headers: {},
    },
  };
  return recoverSuccess;
};

const autoGenerateSuccessEmail = autoGenerateSuccess(MocksDef.EMAIL);

const autoGenerateSuccessCPF = autoGenerateSuccess(MocksDef.DOCUMENT_TYPE.CPF);

const autoGenerateSuccessMember = autoGenerateSuccess(MocksDef.MEMBER_NUMBER);

const generatedSuccessMocks = [
  autoGenerateSuccessEmail,
  autoGenerateSuccessCPF,
  autoGenerateSuccessMember,
];

const autoGenerate = (email: string) => {
  const listOfErrorsMock: IMockProps[] = CODE_ERRORS.map(
    (error: ErrorResponseCodeType) => {
      const formatedError: IMockProps = {
        doc: {
          code: error.code,
          message: error.message,
        },
        configRequest: {
          method: 'POST',
          path: ENDPOINT_API_PATH,
          body: {
            email: `${error.code}-${email}`,
          },
        },
        configResponse: {
          status: 452,
          data: {
            code: error.code,
            message: error.message,
            metadata: error.metadata,
          },
          headers: {},
        },
      };

      return formatedError;
    },
  );
  return listOfErrorsMock;
};
const autoGenerateErrorsMock = () => {
  const responseError = autoGenerate(MocksDef.EMAIL);
  return [...responseError];
};

const errorsGenerated = autoGenerateErrorsMock();

const RecoverBigDataQuestionMocks = [
  ...generatedSuccessMocks,
  ...errorsGenerated,
];
export default RecoverBigDataQuestionMocks;
